export default __webpack_public_path__ + "static/media/4.e73b63fa.png";